class Utils {
  // Formats a given amount as a dollar currency string.

  static isValidColor = (color) => {
    const s = new Option().style;
    s.color = color;
    return s.color !== '';
  };
  static formatDollar(amount) {
    // Regex expression taken from https://stackoverflow.com/questions/2901102
    return '$' + amount.replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
  }

  static formatTodayDate = (date) => {
    const options = {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(date);

    // Extract year, month, and day parts
    const year = parts.find((part) => part.type === 'year').value;
    const month = parts.find((part) => part.type === 'month').value;
    const day = parts.find((part) => part.type === 'day').value;

    // Format as YYYY-MM-DD
    return `${year}-${month}-${day}`;
  };

  //10/26/2024 4:53 p.m.
  static formatDateMMDDYYYYTime = (dateString) => {
    // Parse the date string
    const date = new Date(
      dateString.replace(/(a\.m\.|p\.m\.)/i, 'AM').replace(/(p\.m\.)/i, 'PM')
    );

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  static convertTo12HourFormat = (time24) => {
    // Check if the input time is valid
    if (!/^\d{2}:\d{2}:\d{2}$/.test(time24)) {
      throw new Error('Invalid time format. Expected HH:mm:ss.');
    }

    // Create a new Date object and set hours, minutes, and seconds
    const [hours, minutes, seconds] = time24.split(':').map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(seconds);

    // Format the time using options
    const options = {
      hour: '2-digit',
      minute: '2-digit',
      // second: '2-digit',
      hour12: true, // Use 12-hour clock with AM/PM
    };

    // Convert to 12-hour format
    return date.toLocaleTimeString('en-US', options);
  };

  //2025-06-05T16:14:41Z -> "2025-06-05 11:14 AM"
  static formatDateTime = (timestamp) => {
    if (
      !timestamp ||
      typeof timestamp !== 'string' ||
      timestamp === 'No previous reading date available.'
    ) {
      return 'No previous reading date available.';
    }

    const dateObj = new Date(timestamp);

    if (isNaN(dateObj.getTime())) {
      return 'No previous reading date available.';
    }

    // Format date: YYYY-MM-DD
    const dateFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });

    const parts = dateFormatter.formatToParts(dateObj);
    const year = parts.find((p) => p.type === 'year')?.value;
    const month = parts.find((p) => p.type === 'month')?.value;
    const day = parts.find((p) => p.type === 'day')?.value;

    // Format time: hh:mm AM/PM
    const timeFormatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });

    const time = timeFormatter.format(dateObj);

    return `${year}-${month}-${day} ${time}`;
  };

  static handlePdfAction = (pdfData, action, fileName) => {
    if (!pdfData) return;
    const isMobileApp = window.Toaster && window.Toaster.postMessage;

    if (isMobileApp) {
      const uint8 = new Uint8Array(pdfData);
      let binary = '';

      // ✅ Chunked conversion — safe for large PDFs in mobile WebViews
      const chunk = 8192;
      for (let i = 0; i < uint8.length; i += chunk) {
        binary += String.fromCharCode.apply(null, uint8.subarray(i, i + chunk));
      }

      try {
        const base64String = btoa(binary);
        const mobileAction = action === 'download' ? 'open' : action;

        window.Toaster.postMessage(
          JSON.stringify({
            action: mobileAction,
            base64: base64String,
            fileName: fileName,
          })
        );
      } catch (e) {
        console.error('Base64 Encoding Error:', e);
      }
    } else {
      // FALLBACK: Web Logic
      const blob = new Blob([pdfData], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);

      if (action === 'download') {
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
      } else {
        // Print logic
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobUrl;
        document.body.appendChild(iframe);
        iframe.onload = () => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          setTimeout(() => {
            URL.revokeObjectURL(blobUrl);
            document.body.removeChild(iframe);
          }, 1000);
        };
      }
    }
  };

  // static handlePdfAction = (pdfData, action, fileName) => {
  //   if (!pdfData) return;
  //   const isMobileApp = window.Toaster && window.Toaster.postMessage;
  //
  //   if (isMobileApp) {
  //     // Convert Uint8Array to Base64 string for the Flutter Bridge
  //     const base64String = btoa(
  //       new Uint8Array(pdfData).reduce(
  //         (data, byte) => data + String.fromCharCode(byte),
  //         ''
  //       )
  //     );
  //
  //     const mobileAction = action === 'download' ? 'open' : action;
  //
  //     window.Toaster.postMessage(
  //       JSON.stringify({
  //         action: mobileAction, // 'print' or 'download'
  //         base64: base64String,
  //         fileName: fileName,
  //       })
  //     );
  //   } else {
  //     // FALLBACK: Your existing Web Logic
  //     const blob = new Blob([Uint8Array.from(pdfData)], {
  //       type: 'application/pdf',
  //     });
  //     const blobUrl = URL.createObjectURL(blob);
  //
  //     if (action === 'download') {
  //       let link = document.createElement('a');
  //       link.href = blobUrl;
  //       link.download = fileName;
  //       link.click();
  //       URL.revokeObjectURL(blobUrl);
  //     } else {
  //       // Existing Iframe Print Logic
  //       const iframe = document.createElement('iframe');
  //       iframe.style.display = 'none';
  //       iframe.src = blobUrl;
  //       document.body.appendChild(iframe);
  //       iframe.onload = () => {
  //         iframe.contentWindow.focus();
  //         iframe.contentWindow.print();
  //         setTimeout(() => {
  //           URL.revokeObjectURL(blobUrl);
  //           document.body.removeChild(iframe);
  //         }, 1000);
  //       };
  //     }
  //   }
  // };
}

export default Utils;
